import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

export function Splash() {
  return (
    <SplashScreen>
      <Spin />
    </SplashScreen>
  );
}

const SplashScreen = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
